module.exports = __webpack_public_path__ + "media/assets/images/incorrect-circle-icon-f8e4204635a5bd87295d6bcba675e73e.svg";